import { ShipmentStatusEnum } from "../../../models/Shipments/ShipmentStatus";

/** Sample SIR returns allowed only when linked shipment is terminal for dispatch. */
export function isSampleSirReturnAllowedForShipmentStatus(
  status: number | null | undefined,
): boolean {
  if (status == null || Number.isNaN(Number(status))) {
    return false;
  }
  const s = Number(status);
  return (
    s === ShipmentStatusEnum.DELIVERED ||
    s === ShipmentStatusEnum.RETURNED ||
    s === ShipmentStatusEnum.CANCELLED
  );
}

export function sampleSirReturnShipmentBlockedMessage(
  statusLabel?: string | null,
): string {
  const label = statusLabel?.trim() || "not eligible";
  return `Return is available only after the linked shipment is delivered, returned, or cancelled. Current shipment status: ${label}.`;
}
